LimitedArray = Em.ArrayProxy.extend
  limit: 1

  AUDIO = new Audio('sounds/new.mp3')

  pendingCount: (->
    @get('content.length') - @get('arrangedContent.length')
  ).property('content.length', 'arrangedContent.length')

  hasPendingElements: Em.computed.gt('pendingCount', 0)

  contentArrayDidChange: (array, idx, removedCount, addedCount) ->
    LIMIT = @get('limit')
    arrangedContent = @get('arrangedContent')

    # TODO: не охватывает случай, когда сразу добавили и убрали
    # несколько парней
    # + возможно, упростится логика
    if array.length == 0
      arrangedContent.clear()

    else if removedCount > 0 && idx < LIMIT
      toRemove = removedCount

      arrangedContent.replace( idx, toRemove )
      len = arrangedContent.get('length')
      remained = LIMIT - arrangedContent.get('length')

      if remained > 0
        arrangedContent.replace( len, 0, array.slice( len, len + remained) )

    else if addedCount > 0 && idx < LIMIT
      to = Math.min(idx + addedCount, LIMIT)
      arrangedContent.replace( idx, 0, array.slice(idx, to) )

      if arrangedContent.get('length') > LIMIT
        arrangedContent.replace( LIMIT, arrangedContent.get('length') - LIMIT)

  arrangedContent: null

  init: ->
    @set( 'arrangedContent', Em.A([]) )
    @_super(arguments...)


NotifierService = Em.Service.extend
  queue:        null
  limitedQueue: null

  environment: Em.inject.service('environment')
  session:     Em.inject.service()

  initQueue: (->
    Em.Logger.log 'Создаем очередь уведомлений'

    maxNotifications = @get('environment.maxNotifications') || 5
    @set 'queue', Em.A([])
    @set 'limitedQueue', LimitedArray.create( content: @get('queue'), limit: maxNotifications )

    @set('notifCacheWeb',    {})
    @set('notifCacheNative', {})
  ).on('init')


  notificationProviders: [ 'web', 'native' ]
  ###
  # options:
  #   - type: String := {'success', 'info', 'error', 'warning'}
  #   - title: String - Заголовок
  #   - message: String - Тело сообщения
  #   - duration: (default - 1 сутки)
  #   - handler - обработчик клика
  #   - imageUrl - адрес картинки для отображения
  ###
  pushNotification: (options) ->
    args = arguments

    uid = Math.floor(Math.random() * 0xffffffff)

    @get('notificationProviders').forEach (provider) =>
      providerFunc = "push_notification_#{provider}".camelize()

      if typeof @[providerFunc] == 'function'
        @[providerFunc](uid, args...)

    if options.duration
      Em.run.later(@, @closeNotification.bind(@, uid), options.duration)
    if options.sound
      if options.sound_repeat
        AUDIO.play()
        @playDelayedSound(uid, options.sound_repeat)
      else  
        AUDIO.play()
        


  pushNotificationWeb: (uid, options) ->
    { type, title, message, duration, imageUrl, sound, sound_repeat } = options

    handler = =>
      @closeNotification(uid)
      options?.handler?()

    notification = Em.Object.create
      type:         type
      title:        title
      message:      message
      duration:     duration
      handler:      handler
      imageUrl:     imageUrl
      sound:        sound
      sound_repeat: sound_repeat
      uid:          uid

    @get('queue').unshiftObject( notification )
    @get('notifCacheWeb')[uid] = notification

  playDelayedSound: (uid, repeat_timer) ->
    self = @
    pushExist = self.queue.find (v) -> v.uid == uid
    if pushExist
      Ember.run.later(->
        AUDIO.play()
        self.playDelayedSound(uid, repeat_timer);
      , repeat_timer);
      
      
    

  closeNotification: (uid) ->
    @get('notificationProviders').forEach (provider) =>
      switch provider
        when 'web'
          cache = @get('notifCacheWeb')

          if cache.hasOwnProperty(uid)
            @get('queue').removeObject( cache[uid] )
            delete cache[uid]

        when 'native'
          cache = @get('notifCacheNative')

          if cache.hasOwnProperty(uid)
            cache[uid].close?()
            delete cache[uid]



  ## HTML5 Notifications provider
  requestNativeNotifOnUserChange: (->
    return unless @get('session.currentUser')
    @nativeNotificationsRequestPermission()
  ).observes('session.currentUser')

  nativeNotificationsRequestPermission: ->
    return unless window.hasOwnProperty('Notification')

    if not (Notification.permission in [ 'granted', 'denied' ])
      Notification.requestPermission()

  pushNotificationNative: (uid, options) ->
    return unless window.hasOwnProperty('Notification')

    # Показывать только если окно не в фокусе
    unless document.hidden
      return

    @nativeNotificationsRequestPermission()

    try
      new Notification('')
    catch e
      return false


    title = options.title || 'Smartomato'
    notification = new Notification(title, {
      body: options.message,
      icon: 'images/personal-manager.png'
    })

    notification.onclick = =>
      @closeNotification(uid)
      options?.handler?()

    notification.onclose = =>
      @closeNotification(uid)

    @get('notifCacheNative')[uid] = notification


module.exports = NotifierService
